import React from 'react';
import Text from '../Text/index.js';

/**
 *  Styles Advertising text consistently
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function AdvertisementText(_ref) {
  let {
    children = ['Advertisement'],
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    ...rest,
    color: "subdued-lightest",
    size: 100,
    children: children
  });
}
export default AdvertisementText;